import React from 'react';

const Sale = () => {
  return (
    <div className='row'>
      <div className='col-12'>
        <div className='bg-dark text-center text-white py-2'>
          CHRISTMAS SALE - 25% OFF{' '}
          <span className='text-light-muted ms-3'>added at the checkout</span>
        </div>
      </div>
    </div>
  );
};

export default Sale;
